module.exports = __webpack_public_path__ + "static/media/organization_members.190bead4.svg";